import React from 'react';
import ViewConditionsAction from '@/datasets/conditions/components/ViewConditionsAction';
import Events from '@/datasets/conditions/hooks/events';
import { requestSteps } from '../constants';
import Selectors from '../hooks/selectors';

const RequestWizardActions = ({ category, code }) => {
  const state = Selectors.useRequestWizardActions({ category, code });
  const showConditions = Events.useShowDatasetConditions(state);
  const activeStep = Object.values(requestSteps)[state.activeStepIndex].name;

  return (
    <>
      {state.hasConditions && activeStep !== requestSteps.SOURCE.name && (
        <ViewConditionsAction onClick={() => showConditions(state)} />
      )}
    </>
  );
};

export default RequestWizardActions;
